import { render } from "./SatellitePage.vue?vue&type=template&id=69cb951e&scoped=true"
import script from "./SatellitePage.vue?vue&type=script&lang=js"
export * from "./SatellitePage.vue?vue&type=script&lang=js"

import "./SatellitePage.vue?vue&type=style&index=0&id=69cb951e&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cb951e"]])

export default __exports__